import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import LogFileCellRenderer from 'components/common/logFileCellRenderer'
import { formatDate } from 'utils/helpers'

export enum SapLogStatus {
  PROCESSING = 'processing',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export const getColumns = (page: number): ColDef[] => [
  {
    headerName: 'ID',
    field: 'uuid',
    valueFormatter: (params: ValueFormatterParams) => {
      return String((params.node?.rowIndex as number) + 1 + page)
    },
    maxWidth: 120,
  },
  {
    headerName: 'Request ID',
    field: '_id',
    minWidth: 230,
  },
  {
    headerName: 'Operation Type',
    field: 'type',
    cellClass: 'capitalize',
  },
  {
    headerName: 'Status',
    field: 'status',
    flex: 1,
    cellClass: (params) => {
      const status =
        params.value === SapLogStatus.FAILED
          ? 'text-red-600 font-semibold'
          : params.value === SapLogStatus.SUCCESS
            ? 'text-green-600 font-semibold'
            : 'text-yellow-600 font-semibold'

      return status + ' capitalize'
    },
  },
  {
    headerName: 'Total',
    field: 'totalRecords',
    flex: 1,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value?.toLocaleString() ?? '0',
  },
  {
    headerName: 'Failed',
    field: 'failedCount',
    flex: 1,
    valueFormatter: (params: ValueFormatterParams) =>
      params.value?.toLocaleString() ?? '0',
    cellClass: (params) => {
      return params.value > 0 ? 'text-red-500 font-medium' : ''
    },
  },
  {
    headerName: 'Payload',
    field: 's3Paths.request',
    cellRenderer: (params: ICellRendererParams) => (
      <LogFileCellRenderer params={params} />
    ),
    flex: 2,
  },
  {
    headerName: 'Summary',
    field: 's3Paths.summary',
    cellRenderer: (params: ICellRendererParams) =>
      params.value ? <LogFileCellRenderer params={params} /> : '-',
    flex: 2,
  },
  {
    headerName: 'Started At',
    field: 'createdAt',
    valueFormatter: (params: ValueFormatterParams) =>
      formatDate(params.value, { includeTime: true }),
  },
  {
    headerName: 'Completed At',
    field: 'completedAt',
    valueFormatter: (params: ValueFormatterParams) =>
      params.value ? formatDate(params.value, { includeTime: true }) : '-',
    flex: 1.5,
  },
]
